import async from 'async';
import React from 'react';
import { app, use } from 'xadmin';
import { C, Page, Loading } from 'xadmin-ui';
import { _t } from 'xadmin-i18n'
import { Model, ModelBlock } from 'xadmin-model';
import TabsForm from './TabsForm';
import _ from 'lodash'

const ModelListPage = props => {
  const { model: baseSchema, getModelState, projectFields } = use('model', props)

  return (
    <ExtendsModel schema={baseSchema} state={getModelState()} projectFields={projectFields}>
      {schema => (!schema || _.isEmpty(schema)) ? <Loading /> : (
        <Model schema={schema} modelKey={`${baseSchema.key}_Extends`} id={baseSchema.key}>
          <C is="Model.ListPage" />
        </Model>
      )}
    </ExtendsModel>
  )
}

const ModelFormPage = ({ params, location, router }) => {
  const { model } = use('model')
  const { onSaved } = use('model.event')
  const { data, loading } = use('model.item', { id: params && params.id })

  const title = params && params.id ? _t('Edit {{title}}',
    { title: model.title + ' ' + (data && data[model.displayField || 'name'] || '') }) : _t('Create {{title}}', { title: model.title })
  const FormComponent = (model.components && model.components.DataForm) || TabsForm

  return (
    <Page className={`xadmin-model-form-${model.key}`}
      title={title} onBack={() => history.back()}
      subTitle={<ModelBlock name="model.edit.nav" />}
      actions={<ModelBlock name="model.edit.navbtn" />}
    >
      <ModelBlock name="model.form.before" />
      {loading ? <Loading /> : <FormComponent id={params && params.id} item={data} router={router} location={location} query={location.query} schemaKey={`${_.lowerCase(model.name)}.schema`} onSubmitSuccess={onSaved} />}
      <ModelBlock name="model.form.after" />
    </Page>
  )
}

const ExtendsModel = ({ name, schema: base, data, state, children, projectFields }) => {
  const [schema, setSchema] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const baseSchema = base || app.get('models')[name]

  React.useEffect(() => {
    setLoading(true)
    async.map(app.load_list(`${_.lowerCase(baseSchema.name)}.schema`),
      (item, cb) => {
        if (_.isFunction(item)) {
          item({ model: baseSchema, data, state }, (err, schema) => {
            cb(null, schema);
          });
        } else {
          cb(null, item);
        }
      },
      (err, schemas) => {
        if (err) {
          return;
        }
        const schema = schemas.filter(Boolean).reduce((prev, s) => {
          const key = s.name
          return {
            ...prev,
            properties: {
              ...prev.properties,
              [key]: s
            },
            listFields: [
              ...(prev.listFields || []),
              ...(s.listFields || []).map(f => `${key}.${f}`)
            ].filter(Boolean),
            editableFields: [
              ...(prev.editableFields || []),
              ...(s.editableFields || []).map(f => `${key}.${f}`)
            ].filter(Boolean),
            batchChangeFields: [
              ...(prev.batchChangeFields || []),
              ...(s.batchChangeFields || []).map(f => `${key}.${f}`)
            ].filter(Boolean),
            filters: {
              ...prev.filters,
              submenu: [
                ...(prev.filters && prev.filters.submenu || []),
                ...(s.filters && s.filters.submenu || []).map(f => {
                  if (f && f.key) {
                    return { ...f, key: `${key}.${f.key}` }
                  }
                  return `${key}.${f}`
                })
              ]
            }
          }
        }, baseSchema)

        setSchema({
          ...schema,
          // projectFields 可控制查询条件
          projectFields: [
            ...schema.projectFields || [],
            ...(projectFields == 'all' ? Object.keys(schema.properties) : _.isArray(projectFields) ? projectFields : [])
          ],
          initialValues: state
        })
        setLoading(false)

      }
    )

  }, [baseSchema])
  if (!schema || _.isEmpty(schema)) return loading ? <Loading /> : null
  return children(schema)

}

export {
  ModelListPage,
  ModelFormPage,
  ExtendsModel
}
